/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LongIDResource,
  LongIDResourceOptional,
  LongIDResourceMetaI,
  LongIDResourceTrackedI,
} from "./long-idresource";
import { LongIDResourceTracked, LongIDResourceMeta } from "./long-idresource";

/**
 *
 * @export
 * @interface ReportMetaFull
 */
export interface ReportMetaFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof ReportMetaFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ReportMetaFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ReportMetaFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof ReportMetaFull
   */
  key?: string;
  /**
   *
   * @type {string}
   * @memberof ReportMetaFull
   */
  title?: string;
}

export interface ReportMetaFull
  extends ReportMetaFullOptional, Deletable, LongIDResource {
  /**
   *
   * @type {boolean}
   * @memberof ReportMetaFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ReportMetaFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof ReportMetaFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof ReportMetaFull
   */
  key: string;
  /**
   *
   * @type {string}
   * @memberof ReportMetaFull
   */
  title: string;
}

export interface ReportMetaFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof ReportMetaFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ReportMetaFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ReportMetaFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ReportMetaFull
   */
  key?: string;
  keyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ReportMetaFull
   */
  title?: string;
  titleIsSet: boolean;
}

transformDatesMap.set("ReportMetaFull", function (model: ReportMetaFull) {});

export type ReportMetaFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  key: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  title: PropertyMeta<MetaTypeBase<string>>;
}>;

export var ReportMetaFullMeta: ReportMetaFullMetaI = {} as ReportMetaFullMetaI;
ReportMetaFullMeta = typeMeta("ReportMetaFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  key: propertyMeta("key", false, true, false, MetaTypesBase.string),
  title: propertyMeta("title", false, true, false, MetaTypesBase.string),
});

const metaI = ReportMetaFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([LongIDResourceMeta]);
  metaI.assignId.inheritedFrom = LongIDResourceMeta.assignId;
});

export class ReportMetaFullTracked
  extends DeletableTracked
  implements ReportMetaFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  key__I?: string = undefined;
  keyIsSet: boolean = false;
  set key(v: undefined | string) {
    if (v !== undefined) {
      this.key__I = v;
      this.keyIsSet = true;
    } else {
      this.key__I = v || undefined;
      this.keyIsSet = true;
    }
    this.changeTracker = true;
  }
  get key() {
    return this.key__I;
  }
  title__I?: string = undefined;
  titleIsSet: boolean = false;
  set title(v: undefined | string) {
    if (v !== undefined) {
      this.title__I = v;
      this.titleIsSet = true;
    } else {
      this.title__I = v || undefined;
      this.titleIsSet = true;
    }
    this.changeTracker = true;
  }
  get title() {
    return this.title__I;
  }
  constructor(config?: ReportMetaFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: ReportMetaFullOptional,
    options?: AssignOptions,
  ): ReportMetaFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.key && this.keyApplyFilter(optionsRequired.filter)) {
      this.key = config.key;
      if (optionsRequired.unassign) this.keyIsSet = false;
      else this.keyIsSet = true;
    }
    if (config.title && this.titleApplyFilter(optionsRequired.filter)) {
      this.title = config.title;
      if (optionsRequired.unassign) this.titleIsSet = false;
      else this.titleIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ReportMetaFullTrackedI {
    const cloned = {} as ReportMetaFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.keyIsSetDeep() &&
      this.keyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.keyIsSet = true;
      cloned.key = this.key;
    } else {
      //cloned.keyIsSet = false
    }
    if (
      this.titleIsSetDeep() &&
      this.titleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.titleIsSet = true;
      cloned.title = this.title;
    } else {
      //cloned.titleIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ReportMetaFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.keyApplyFilter(filter)) this.keyIsSet = false;

    if (!this.titleApplyFilter(filter)) this.titleIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportMetaFullMeta.isDeleted,
      ReportMetaFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportMetaFullMeta.isNew,
      ReportMetaFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportMetaFullMeta.assignId,
      ReportMetaFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  keyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(ReportMetaFullMeta.key, ReportMetaFullMeta, this.key, this);
  }
  keyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.keyIsSet && this.keyApplyFilter(filter)) return true;

    return false;
  }
  titleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ReportMetaFullMeta.title,
      ReportMetaFullMeta,
      this.title,
      this,
    );
  }
  titleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.titleIsSet && this.titleApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.keyIsSetDeep(filter)) return true;
    if (this.titleIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
